<template>
  <!-- <pre v-if="responseData"> testData={{ JenisChartData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/CERUN.png"
        alt="CERUN"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>
      </div>
      <h2>Cerun</h2>
      <div class="vektor">
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Bilangan Keseluruhan PBT Tiada Cerun</h3>
              <p class="number">
                {{ numberWithCommas(pbtTiadaCerun) }}
              </p>
            </div>
          </div>
        </div>

        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Jumlah Cerun</h3>
              <p class="number">
                {{ numberWithCommas(jumlahCerun) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-container">
        <div class="chart-wrapper"> 
          <h2>Bilangan Cerun Mengikut Kategori</h2> 
          <Bar 
            :chart-data="KategoriChartData"
            :chart-categories="KategoriChartNames"
            :chart-colors="['rgb(16, 185, 129)', 'rgb(245, 158, 11)', 'rgb(239, 68, 68)']"
          />
        </div>

        <div class="chart-wrapper">  
          <h2>Bilangan Cerun Mengikut Jenis Cerun</h2>
          <Bar 
            :chart-data="JenisChartData"
            :chart-categories="JenisChartNames"
            :chart-colors="['#42a5f5']"
          />
        </div>
      </div>

      <div class="chart-container">
        <div class="chart-wrapper">  
          <h2>Bilangan Cerun Mengikut Kelas</h2>
          <Bar 
            :chart-data="KelasChartData"
            :chart-categories="KelasChartNames"
            :chart-colors="['#00c057', '#ffbf87', '#ff922e', '#f00000', '#6b7080']"
          />
        </div>
      
        <div class="chart-wrapper">  
          <h2>Pengkelasan Cerun</h2>
          <img
            src="@/assets/jkt/PBT/kelascerun.png"
            alt="Pengkelasan Cerun"
            class="classification-image"
          >
          <p class="source-text">
            (Sumber: Garis Panduan Perancangan Pembangunan Di Kawasan Bukit dan Tanah Tinggi, 2009)
          </p>
        </div>
      </div>

      <div class="chart-wrapper">  
        <h2>Penerangan Kategori Cerun</h2>
        <table class="cerun-table">
          <thead>
            <tr>
              <th>BIL</th>
              <th>KATEGORI PBT</th>
              <th>PENERANGAN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>PBT Kategori Hijau - Kriteria Risiko Rendah</td>
              <td>
                Cerun Kelas I dan Kelas II;
                <ul>
                  <li>a) Ada sejarah kegagalan, ada penyenggaraan</li>
                  <li>b) Ada sejarah kegagalan, tiada penyenggaraan</li>
                  <li>c) Tiada sejarah kegagalan, tiada penyenggaraan</li>
                  <li>d) Tiada sejarah kegagalan, ada penyenggaraan</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>PBT Kategori Kuning - Kriteria Risiko Sederhana</td>
              <td>
                Cerun Kelas III dan Kelas IV;
                <ul>
                  <li>a) Tiada sejarah kegagalan, ada penyenggaraan</li>
                  <li>b) Tiada sejarah kegagalan, tiada penyenggaraan</li>
                  <li>c) Ada sejarah kegagalan, ada penyenggaraan</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>PBT Kategori Merah - Kriteria Risiko Tinggi</td>
              <td>
                Cerun Kelas III dan IV;
                <ul>
                  <li>Ada sejarah kegagalan, tiada penyenggaraan</li>
                </ul>
                Cerun Kelas I, II, III, dan IV;
                <ul>
                  <li>Ada tanda-tanda kegagalan</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>    
      <div class="chart-container">
        <div class="chart-wrapper">  
          <PieChart
            :chart-data="sejarahData"
            chart-title="Sejarah Kegagalan"
          />
        </div>

        <div class="chart-wrapper">  
          <PieChart
            :chart-data="penyenggaraanData"
            chart-title="Penyenggaraan"
          />
        </div>
      </div>

      <div class="chart-container">
        <div class="chart-wrapper">  
          <PieChart
            :chart-data="kegagalanData"
            chart-title="Tanda Kegagalan"
          />
        </div>

        <!--
          <div class="chart-wrapper">  
          <PieChart
          :chart-data="peratusanData"
          chart-title="Peratusan Data"
          />
          </div> 
        -->
      </div>

      <!--
        <h2>TABURAN CERUN</h2>  
        <MapNew /> 
      -->    
      <PrimaryModule />
      <KejuruteraanAwamMenu />
    </div>
  </adminbackground>
</template>


<script setup>
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')


const KategoriChartData = ref([])
const KategoriChartNames = ref([])

const KelasChartData = ref([])
const KelasChartNames = ref([])

const JenisChartData = ref([])
const JenisChartNames = ref([])

const sejarahData = ref([])
const penyenggaraanData = ref([])
const kegagalanData = ref([])
const peratusanData=ref([])


definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})



const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)
const jumlahCerun =  ref(null)
const pbtTiadaCerun =  ref(null)


async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    const plainStates = toRaw(state)
    let queryParams = `year=${year}`
    console.log('Plain states:', plainStates)

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    const url = `kejuruteraan-awam/cerun?${queryParams}`
    const response = await httpGet(url)

    years.value = response.years
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils

    responseData.value = response
    pbtTiadaCerun.value = response.data.jumlah_pbt_tiada_cerun
    jumlahCerun.value = response.data.jumlah_cerun

    const kategori = responseData.value.data.kategori_cerun

    KategoriChartNames.value = Object.keys(kategori)
    KategoriChartData.value  = Object.values(kategori)

    const kelas = responseData.value.data.kelas_cerun

    KelasChartNames.value  = Object.keys(kelas).map(key => {
      if (key === "TD") return "Tiada Data"
      
      return key 
    })
    KelasChartData.value = Object.values(kelas)

    const jenis = responseData.value.data.jenis_cerun

    JenisChartNames.value = Object.keys(jenis).map(key => {
      if (key === "Man-made") return "Buatan"
      if (key === "Semulajadi") return "Semula Jadi"
      if (key === "TD") return "Tiada Data"
      
      return key 
    })

    JenisChartData.value = Object.values(jenis)

    const sejarah = responseData.value.data.sejarah_kegagalan

    sejarahData.value = Object.entries(sejarah).map(
      ([name, value]) => ({
        name: name === 'td' ? 'Tiada Data' : name === 'ada' ? 'Ada' : name === 'tiada' ? 'Tiada' : name,
        value,
      }),
    )

    const penyenggaraan = responseData.value.data.penyenggaraan

    penyenggaraanData.value = Object.entries(penyenggaraan).map(
      ([name, value]) => ({
        name: name === 'td' ? 'Tiada Data' : name === 'ada' ? 'Ada' : name === 'tiada' ? 'Tiada' : name,
        value,
      }),
    )

    const kegagalan = responseData.value.data.tanda_kegagalan

    kegagalanData.value = Object.entries(kegagalan).map(
      ([name, value]) => ({
        name: name === 'td' ? 'Tiada Data' : name === 'ada' ? 'Ada' : name === 'tiada' ? 'Tiada' : name,
        value,
      }),
    )

    const peratusan = responseData.value.data.peratusan

    peratusanData.value = Object.entries(peratusan).map(
      ([name, value]) => ({
        name: name === 'td' ? 'Tiada Data' : name === 'ada' ? 'Ada' : name === 'tiada' ? 'Tiada' : name,
        value,
      }),
    )
    
  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
  
})

watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })

watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>



<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); 
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%;
  height: auto;
}

.line-under-image {
  width: 70%; 
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px; 
  text-align: left; 
  text-transform: uppercase;
  width: 100%;
}



.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.input-item {
  flex: 1;
  margin-right: 15px;
}

.input-item:last-child {
  margin-right: 0;
}

.vektor {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px; 
}

.vektor-container {
  width: 48%;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}


.activity-box {
  position: relative;
  display: inline-block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.box-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}

.box-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #150069;
}

.box-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #a80000;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); 
  gap: 30px; 
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; 
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.chart-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.chart-wrapper {
  flex: 1;
  min-width: 48%; /* Ensures two charts per row */
  max-width: 48%; /* Ensures two charts per row */
  background: rgba(255, 254, 254, 0.8);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}
.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  block-size: auto;
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

.cerun-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: #fff;
}

.cerun-table th, .cerun-table td {
  border: 1px solid #000000;
  padding: 8px;
  color: #000000;
  text-align: left;
}

.cerun-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #150069;
}

.cerun-table td ul {
  margin: 0;
  padding-left: 20px;
  
  list-style-type: none;
}

.cerun-table td ul li {
  color: #000000;
  margin-bottom: 5px;
}
.classification-image {
  margin-top: 105px;
  max-width: 90%;
  height: auto;
}


.source-text {
  font-size: 0.9rem;
  color: #666;
  margin-top: 105px;
  text-align: center;
  font-style: italic;
}

@media (max-width: 768px) {
  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .vektor {
    flex-direction: column;
    gap: 20px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .values-layered h3 {
    font-size: 16px;
  }

  .number {
    font-size: 20px;
  }

  .chart-container {
    flex-direction: column;
  }

  .chart-wrapper {
    max-width: 100%; 
  }
}

@media (max-width: 480px) {
  .pbt-image {
    max-width: 70%;
  }

  .line-under-image {
    width: 70%;
  }

  h2 {
    font-size: 1.1rem;
  }

  .values-layered h3 {
    font-size: 14px;
  }

  .number {
    font-size: 18px;
  }

  .input-item {
    width: 100%;
    margin-right: 0;
  }

  .vektor-container {
    width: 100%;
  }

  .chart-wrapper {
    padding: 10px;
    margin-bottom: 30px;
  }
}
</style>

